import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CanLoad, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { StorageService } from 'src/app/services/storage/storage.service';

/**
 * Auth guard for the Auth Portal page
 * 
 * (Using canLoad because it prevents loading the path earlier than canActivate)
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanLoad {

  constructor(
    private router: Router,
    private storage: StorageService,
    private authService: AuthenticationService
  ) {}

  canLoad(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {    
    return this.storage.get("Auth_Token").then(token => {
      if(token) {
        return Promise.resolve(true);
      } else {
        this.authService.logout();
        this.router.navigateByUrl('/login');
        return Promise.resolve(false);
      }
    });
  }
}
